import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { addBank } from "../../redux/Banks/banksSlice";
import StatusSelect from "../../components/CustomSelect/StatusSelect";
import CustomInput from "../../components/CustomInput/CustomInput";
import { NavLink } from "react-router-dom";

function BanksActions() {
  const dispatch = useDispatch();
  const { addBankModalValues } = useSelector((state) => state.banks);

  const {
    formState: { errors, isValid },
    handleSubmit,
    reset,
    control,
  } = useForm({
    defaultValues: addBankModalValues,
  });

  const resetAddBankModalValues = () => {
    reset(addBankModalValues);
  };

  const handleAddBank = (data) => {
    dispatch(addBank(data));
    resetAddBankModalValues();
  };

  return (
    <>
      <nav className="uk-position-relative" aria-label="Breadcrumb">
        <ul className="uk-breadcrumb">
          <li>
            <NavLink to="/">الرئيسية</NavLink>
          </li>
          <li>
            <span aria-current="page">الممولين</span>
          </li>
        </ul>
        <button
          className="uk-button uk-button-primary uk-button-small uk-border-rounded uk-position-left"
          uk-toggle="target: #addBankModal"
        >
          <span className="uk-margin-small-left" uk-icon="plus"></span>
          إنشاء
        </button>
      </nav>

      {/* Add Bank Modal */}
      <div id="ModalOfAddBank">
        <div
          id="addBankModal"
          uk-modal="bg-close: false"
          container="#ModalOfAddBank"
        >
          <div className="uk-modal-dialog">
            <button
              className="uk-modal-close-default"
              type="button"
              uk-close=""
              onClick={resetAddBankModalValues}
            ></button>
            <div className="uk-modal-header uk-text-center">
              <h2 className="uk-modal-title">إضافة بنك</h2>
            </div>
            <div className="uk-modal-body">
              <form className="uk-grid-small uk-child-width-1-2" uk-grid="">
                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    الإسم بالعربي
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <CustomInput
                      control={control}
                      name="nameAr"
                      error={errors.nameAr}
                    />
                  </div>
                </div>
                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    الإسم بالإنجليزي
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <CustomInput
                      control={control}
                      name="nameEn"
                      error={errors.nameEn}
                    />
                  </div>
                </div>
                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                  نسبة الربح  عسكري
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <CustomInput
                      control={control}
                      name="finance_rate_Military"
                      error={errors.finance_rate_Military}
                      type="number"
                    />
                  </div>
                </div>
                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                  نسبة الربح حكومي مدني
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <CustomInput
                      control={control}
                      name="finance_rate_Civilian"
                      error={errors.finance_rate_Civilian}
                      type="number"
                    />
                  </div>
                </div>
                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                  نسبة الربح  خاص معتمد
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <CustomInput
                      control={control}
                      name="finance_rate_Official"
                      error={errors.finance_rate_Official}
                      type="number"
                    />
                  </div>
                </div>
                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                  نسبة الربح خاص غير معتمد
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <CustomInput
                      control={control}
                      name="finance_rate_Unofficial"
                      error={errors.finance_rate_Unofficial}
                      type="number"
                    />
                  </div>
                </div>

                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    نسبة التأمين
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <CustomInput
                      control={control}
                      name="insurance_rate"
                      error={errors.insurance_rate}
                      type="number"
                    />
                  </div>
                </div>
                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    نسبة المشاركة
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <CustomInput
                      control={control}
                      name="ownership_rate"
                      error={errors.ownership_rate}
                      type="number"
                    />
                  </div>
                </div>
                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    الرسوم الإدارية
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <CustomInput
                      control={control}
                      name="administrative_fees"
                      error={errors.administrative_fees}
                      type="number"
                    />
                  </div>
                </div>
                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    الترتيب
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <CustomInput
                      control={control}
                      name="order"
                      error={errors.order}
                      type="number"
                    />
                  </div>
                </div>
                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    الحالة
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <Controller
                      name="status"
                      control={control}
                      render={({ field }) => (
                        <StatusSelect field={field} error={errors.status} />
                      )}
                      rules={{
                        validate: (v) =>
                          typeof v == "boolean" || "هذا الحقل مطلوب!",
                      }}
                    />
                  </div>
                </div>
              </form>
            </div>
            <div className="uk-modal-footer uk-text-left">
              <button
                className={`uk-button uk-button-secondary uk-margin-small-left uk-border-rounded${
                  isValid ? " uk-modal-close" : ""
                }`}
                type="button"
                onClick={handleSubmit(handleAddBank)}
              >
                إضافه
              </button>
              <button
                className="uk-button uk-button-primary uk-modal-close uk-border-rounded"
                type="button"
                onClick={resetAddBankModalValues}
              >
                إلغاء
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BanksActions;
